import React from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessIcon from "@mui/icons-material/Business";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {grey} from "@mui/material/colors";
import {GlobalAccountType} from "../domain/GlobalAccountType";

const globalAccountTypeIconColor = grey[700];

export function buildGlobalAccountTypeIcon(globalAccountType: GlobalAccountType) {
    if (globalAccountType === GlobalAccountType.EMPLOYEE) {
        return <BusinessIcon sx={{color: globalAccountTypeIconColor}}/>;
    } else if (globalAccountType === GlobalAccountType.ADVISOR) {
        return <BusinessCenterIcon sx={{color: globalAccountTypeIconColor}}/>;
    } else if (globalAccountType === GlobalAccountType.CUSTOMER) {
        return <AccountCircleIcon sx={{color: globalAccountTypeIconColor}}/>;
    } else {
        return <HelpOutlineIcon sx={{color: globalAccountTypeIconColor}}/>;
    }
}
